import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

interface WidgetData {
  icon: React.ReactElement;
  title: string;
  description: string;
  route: string;
}

interface WidgetsGridProps {
  widgets: WidgetData[];
}

const WidgetsGrid: React.FC<WidgetsGridProps> = ({ widgets }) => {
  const navigate = useNavigate();
  return (
    <Grid
      container
      spacing={1}
      sx={{
        mt: '-250px',
      }}
    >
      {widgets.map((widget, index) => (
        <Grid item xs={4} lg={4} key={index}>
          <Paper
            variant="outlined"
            sx={{
              width: '25vw',
              minWidth: '210px',
              maxWidth: '360px',
              height: '100px',
              borderColor: '#000000',
              '&:hover': {
                backgroundColor: 'rgba(212, 224, 240, .2)',
                cursor: 'pointer',
              },
              '@media (max-width: 1200px)': { height: '165px' },
            }}
            // On click navigate to the route provided
            onClick={() =>
              navigate(widget.route, {
                viewTransition: true,
              })
            }
          >
            <Container
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '98%',
                height: '95%',
              }}
            >
              {widget.icon}
              <div style={{ marginLeft: '10px', textAlign: 'start' }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: '700',
                    fontSize: '20px',
                  }}
                >
                  {widget.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: 'grey', fontSize: '15px' }}
                >
                  {widget.description}
                </Typography>
              </div>
            </Container>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default WidgetsGrid;
